/**
 * Shared background treatment for hub-hosted monograph apps.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

export function monographRouteBackground(
  top: string,
  base: string,
  lower = base,
): string {
  return [
    `radial-gradient(circle at 18% 0%, color-mix(in srgb, ${top} 70%, var(--csk-accent) 30%) 0%, transparent 34rem)`,
    "radial-gradient(circle at 82% 10%, color-mix(in srgb, var(--csk-inert) 12%, transparent) 0%, transparent 30rem)",
    "linear-gradient(180deg, color-mix(in srgb, var(--csk-surface) 5%, transparent) 0%, transparent 18rem)",
    `linear-gradient(160deg, color-mix(in srgb, ${base} 92%, #111827 8%) 0%, color-mix(in srgb, ${lower} 88%, #0f172a 12%) 100%)`,
  ].join(", ");
}
